import { render } from "./Yellow.vue?vue&type=template&id=f2f04786&scoped=true&ts=true"
import script from "./Yellow.vue?vue&type=script&lang=ts"
export * from "./Yellow.vue?vue&type=script&lang=ts"

import "./Yellow.vue?vue&type=style&index=0&id=f2f04786&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f04786"]])

export default __exports__